import classnames from 'classnames'
import { bool, func, number } from 'prop-types'

import IconCaretLeft from 'views/components/atoms/Icon/IconCaretLeft'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'

import { DELIMITER, getPageItems } from './helpers'
import PaginationControl from './PaginationControl'
import PaginationItem from './PaginationItem'

import './Pagination.scss'

const renderPageItems = ({
  pageItems,
  currentPageNum,
  onClick,
  scrollToTopAfterClick,
}) => {
  let lastPageNum

  return pageItems.map((pageNum, index) => {
    let label
    let pageNumFinal

    if (pageNum) {
      label = `${pageNum}`
      pageNumFinal = pageNum
    } else {
      label = DELIMITER
      pageNumFinal = typeof lastPageNum === 'undefined' ? 1 : lastPageNum + 1
    }

    const isCurrent = pageNum === currentPageNum
    lastPageNum = pageNum

    return (
      <li key={`${label}-${index}`}>
        <PaginationItem
          {...{
            label,
            isCurrent,
            pageNum: pageNumFinal,
            onClick,
            scrollToTopAfterClick,
          }}
        />
      </li>
    )
  })
}

const Pagination = ({
  currentPageNum,
  maxPageNum,
  showLabel,
  small,
  onPageItemClick,
  onNextPageItemClick,
  onPrevPageItemClick,
  maxPageItemsCount,
  scrollToTopAfterClick,
}) => {
  const pageItems = getPageItems({
    currentPageNum,
    maxPageNum,
    maxPageItemsCount,
  })
  const listClassName = classnames(
    'm-Pagination l-flex l-flex--justify-content--end u-no-padding',
    {
      'm-Pagination--small': small,
    }
  )

  const labelClassName = classnames({
    'u-margin--right': currentPageNum === 1,
  })

  return (
    <ul className={listClassName}>
      {showLabel && (
        <li className={labelClassName}>
          <span className="a-label">Seite:</span>
        </li>
      )}
      {currentPageNum > 1 && (
        <li>
          <PaginationControl
            icon={<IconCaretLeft size="small" />}
            textLabel="Previous"
            onClick={onPrevPageItemClick}
            pageNum={currentPageNum - 1}
            scrollToTopAfterClick={scrollToTopAfterClick}
            name="pagination-control-prev"
          />
        </li>
      )}
      {renderPageItems({
        pageItems,
        currentPageNum,
        onClick: onPageItemClick,
        scrollToTopAfterClick,
      })}
      {currentPageNum < maxPageNum && (
        <li>
          <PaginationControl
            icon={<IconCaretRight size="small" />}
            textLabel="Next"
            onClick={onNextPageItemClick}
            pageNum={currentPageNum + 1}
            scrollToTopAfterClick={scrollToTopAfterClick}
            name="pagination-control-next"
          />
        </li>
      )}
    </ul>
  )
}

Pagination.propTypes = {
  currentPageNum: number.isRequired,
  maxPageNum: number.isRequired,
  maxPageItemsCount: number,
  onPageItemClick: func,
  onPrevPageItemClick: func,
  onNextPageItemClick: func,
  showLabel: bool,
  small: bool,
  scrollToTopAfterClick: bool,
}

Pagination.defaultProps = {
  maxPageItemsCount: 5,
  showLabel: true,
  small: false,
  onPageItemClick: null,
  onPrevPageItemClick: null,
  onNextPageItemClick: null,
  scrollToTopAfterClick: false,
}

export default Pagination
